import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { enrollmentService } from '@/services/enrollment-service';
import type {
  EnrollmentCredential,
  EnrollmentCredentialKind,
} from '@/types/core/enrollment';
import type { UUID } from '@/utils/uuid';

import { enrollmentQueryKeys } from './query-keys';

/**
 * List the tenant's enrollment credentials, optionally filtered by kind.
 * Lifecycle and audit state only — never secret material.
 */
export function useListEnrollmentCredentials(
  tenantId: UUID | undefined,
  kind?: EnrollmentCredentialKind
): UseQueryResult<EnrollmentCredential[], Error> {
  return useQuery<EnrollmentCredential[], Error>({
    queryKey: enrollmentQueryKeys.credentials(tenantId, kind),
    queryFn: () => enrollmentService.listCredentials(tenantId!, kind),
    enabled: !!tenantId,
  });
}
